<app-header-component
  class="box-shadow-bottom"
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>

<ion-content class="ion-padding">
  <div class="terms-content" *ngIf="useAccountContent">
    <b class="fs-4 font600 text-color">{{"terms_and_conditions.terms_and_conditions" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"terms_and_conditions.your_access_to_and_use_of_the_website" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"terms_and_conditions.use_of_information" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"terms_and_conditions.information_on_this_website_is_provided_by_Travelx" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"terms_and_conditions.Trademarks_and_proprietary_rights" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"terms_and_conditions.all_Travelx_names_and_Travelx_logos_appearing_on_this_site" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"terms_and_conditions.disclaimer" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"terms_and_conditions.while_Travelx_uses_reasonable_efforts_to_ensure_that_the_information" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      {{"terms_and_conditions.this_website_and_documents_on_this_website_contain_certain" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      {{"terms_and_conditions.all_forward_looking_statements_are_based_only_on_data_available_to_Travelx" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      {{"terms_and_conditions.travelx_shall_not_be_liable_for_any_direct_incidental_consequential" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      {{"terms_and_conditions.onthing_on_this_website_constitutes_an_invitation" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"terms_and_conditions.information_you_supply_to_us" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"terms_and_conditions.except_for_information_covered_by_our_Privacy_Policy" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"terms_and_conditions.product_availability" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"terms_and_conditions.this_website_may_contain_information_on_worldwide_products_and_services" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"terms_and_conditions.links_to_our_website" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"terms_and_conditions.travelx_does_not_review_any_third_party_websites_that_contain" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"terms_and_conditions.please_refer_to_Terms" | translate}} &amp; {{"terms_and_conditions.conditions_applicable_to_induvial_service" | translate}}
    </p>
  </div>

  <div class="terms-content" *ngIf="!useAccountContent">
    <b class="fs-4 font600 text-color">{{
      "terms_and_conditions.bfl_document_title" | translate
    }}</b>
    <p class="fs-3 font600 text-color">{{
      "terms_and_conditions.bfl_document_subtitle" | translate
    }}</p>
    <p class="fs-2 font400 text-color">
      <b>{{ "terms_and_conditions.bfl_last_updated_label" | translate }}</b>
      {{ "terms_and_conditions.bfl_last_updated" | translate }}
    </p>
    <p class="fs-2 font400 text-color">
      <b>{{ "terms_and_conditions.bfl_campaign_validity_label" | translate }}</b>
      {{ "terms_and_conditions.bfl_campaign_validity_before" | translate }}
      <b>{{ "terms_and_conditions.bfl_campaign_validity_date" | translate }}</b>
      {{ "terms_and_conditions.bfl_campaign_validity_after" | translate }}
    </p>

    <ng-container *ngFor="let n of bflSectionNumbers">
      <b class="fs-3 font600 text-color">{{
        ("terms_and_conditions.section_" + n + "_title") | translate
      }}</b>
      <p *ngIf="n === 1" class="fs-2 font400 text-color bfl-plain-text">
        {{ "terms_and_conditions.section_1_content_before" | translate }}
        <b>{{ "terms_and_conditions.section_1_mirai_labs" | translate }}</b>
        {{ "terms_and_conditions.section_1_content_after" | translate }}
      </p>
      <p *ngIf="n !== 1" class="fs-2 font400 text-color bfl-plain-text">{{
        ("terms_and_conditions.section_" + n + "_content") | translate
      }}</p>
    </ng-container>

    <ng-container *ngFor="let s of bflSchedules">
      <b class="fs-3 font600 text-color">{{
        ("terms_and_conditions.schedule_" + s + "_title") | translate
      }}</b>
      <p class="fs-2 font400 text-color bfl-plain-text">{{
        ("terms_and_conditions.schedule_" + s + "_content") | translate
      }}</p>
    </ng-container>

    <p class="fs-2 font400 text-color bfl-important-note">
      <b>{{ "terms_and_conditions.bfl_important_label" | translate }}</b>
      {{ "terms_and_conditions.bfl_important_note" | translate }}
    </p>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button
      expand="block"
      class="primary-btn ion-margin fs-3 font500"
      mode="ios"
      (click)="closeModal()"
    >
      {{ "terms_and_conditions.close" | translate }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
